/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogoResource
 */
export interface LogoResource {
    /**
     * 
     * @type {string}
     * @memberof LogoResource
     */
    absoluteUrl: string;
    /**
     * 
     * @type {string}
     * @memberof LogoResource
     */
    baseUrl: string;
    /**
     * 
     * @type {string}
     * @memberof LogoResource
     */
    fileName: string;
}

/**
 * Check if a given object implements the LogoResource interface.
 */
export function instanceOfLogoResource(value: object): value is LogoResource {
    if (!('absoluteUrl' in value) || value['absoluteUrl'] === undefined) return false;
    if (!('baseUrl' in value) || value['baseUrl'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function LogoResourceFromJSON(json: any): LogoResource {
    return LogoResourceFromJSONTyped(json, false);
}

export function LogoResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogoResource {
    if (json == null) {
        return json;
    }
    return {
        
        'absoluteUrl': json['absoluteUrl'],
        'baseUrl': json['baseUrl'],
        'fileName': json['fileName'],
    };
}

export function LogoResourceToJSON(value?: LogoResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'absoluteUrl': value['absoluteUrl'],
        'baseUrl': value['baseUrl'],
        'fileName': value['fileName'],
    };
}

